import { useFlag } from '@calendly/feature-check-react'
import { I18n } from '@calendly/i18n'
import { Badge } from '@calendly/ui/components/badge'
import { Tabs, Tab } from '@calendly/ui/components/tabs'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { useDispatch } from 'react-redux'

import { pushQueryParams } from 'actions/core/navigation'
import { useQueryParams } from 'hooks/use_query_params'


const TABS = [
  { name: 'my_workflows', newFeature: false },
  { name: 'admin_managed_workflows', newFeature: true }
]

// i18n-tasks-use t('publisher.workflows.my_workflows')
// i18n-tasks-use t('publisher.workflows.admin_managed_workflows')
export const WorkflowTabs = () => {
  const dispatch = useDispatch()
  const isPhone = useDeviceType('isPhone')
  const { admin_managed: adminManaged } = useQueryParams()
  const managedWorkflowsEnabled = useFlag('raven_admin_managed_workflows_feature')
  const selectedTab = adminManaged ? 'admin_managed_workflows' : 'my_workflows'
  const showTabs = !isPhone && managedWorkflowsEnabled
  const onTabClick = (tabName) => () => {
    const params = {}
    if (tabName === 'admin_managed_workflows') {
      params.admin_managed = true
    }
    dispatch(pushQueryParams(params))
  }

  if (!showTabs) {
    return null
  }

  return (
    <Tabs>
      {
        TABS.map(({ name, newFeature }) => (
          <Tab
            key={name}
            onClick={onTabClick(name)}
            selected={selectedTab === name}
          >
            {I18n.t(`publisher.workflows.${name}`)}
            {
              newFeature && (
                <>
                  &nbsp;
                  <Badge type="new">{I18n.t('publisher.action.new')}</Badge>
                </>
              )
            }
          </Tab>
        ))
      }
    </Tabs>
  )
}
